import { render, staticRenderFns } from "./detalleDepartamentos.vue?vue&type=template&id=6a7728f8"
import script from "./detalleDepartamentos.vue?vue&type=script&lang=js"
export * from "./detalleDepartamentos.vue?vue&type=script&lang=js"
import style0 from "./detalleDepartamentos.vue?vue&type=style&index=0&id=6a7728f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports